import { useContext } from 'react'
import BootstrapDataContext from '../../context/BootstrapDataContext'
import useSeti from './useSeti'

export default function usePrePopFormSubHeadline(
  experimentCode: string,
  shouldFireImpression = true
) {
  const { prePopData } = useContext(BootstrapDataContext)
  const endLocation = prePopData?.hotels?.endLocation
  const hasCity = !!endLocation?.cityName && endLocation?.type === 'CITY'
  const isImpressionTracked = shouldFireImpression && hasCity
  const isVariant = useSeti(experimentCode, isImpressionTracked) === 'VARIANT'
  return hasCity && isVariant
    ? `Great deals on ${endLocation?.cityName} hotels and private homes`
    : null
}
